import { render } from "./DefaultUi.vue?vue&type=template&id=68cba2ac&scoped=true"
import script from "./DefaultUi.vue?vue&type=script&lang=js"
export * from "./DefaultUi.vue?vue&type=script&lang=js"

import "./DefaultUi.vue?vue&type=style&index=0&id=68cba2ac&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68cba2ac"]])

export default __exports__